export const toastConfig = {
    autoClose: 3000,
};